export default __webpack_public_path__ + "static/media/player_2_1.4ea0e9cd.png";